import { CONTRACT_STEPS } from 'services/stepper/constants'

export const getExistCUPTenure = (selectedTenure, supplyModeService) => {
  const existTenureSelectedCUPS = !!selectedTenure[`${supplyModeService}Cups`] || false
  const existTenureSelectedProduct = selectedTenure?.products?.some(({ type }) => type.toLowerCase() === supplyModeService)
  return existTenureSelectedCUPS && existTenureSelectedProduct
}

export const getStepIndex = (stepId) => CONTRACT_STEPS.findIndex(({ id }) => id === stepId)
